import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal, TiltCard } from '../components/motion';
import { PRODUCTS } from './productsData';
import { AIProductShowcase, ProductSuiteSection, ProspectSection, VisibilitySection } from './sections';
import './productCategory.css';

export default function Products() {
  return (
    <>
      <section className="page-hero">
        <Reveal className="page-hero-inner">
          <div className="section-tag">THE PLATFORM</div>
          <h1>Seven products. One customer record.</h1>
          <p>Profile, search, reviews, social, website, reporting, and AI visibility — each is its own product, and they all work together.</p>
          <div className="page-hero-actions">
            <Link to="/signup" className="btn-primary">Create your account <ArrowRight size={16} /></Link>
            <Link to="/pricing" className="btn-ghost">See what each plan includes</Link>
          </div>
        </Reveal>
      </section>

      <section className="product-more" style={{ background: 'transparent' }}>
        <div className="product-more-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
          {PRODUCTS.map((product, index) => {
            const Icon = product.icon;
            return (
              <TiltCard as="article" className="product-more-card" intensity={6} lift={6} key={product.slug} style={{ '--i': index }}>
                <Link to={`/products/${product.slug}`}>
                  <span className="product-more-icon"><Icon size={17} /></span>
                  <h3>{product.name}</h3>
                  <p>{product.tagline}</p>
                  <span className="product-more-cta">View product <ArrowRight size={13} /></span>
                </Link>
              </TiltCard>
            );
          })}
        </div>
      </section>

      <VisibilitySection />
      <ProspectSection />
      <AIProductShowcase />
      <ProductSuiteSection />
    </>
  );
}
